module.exports = __webpack_public_path__ + "static/memsource-create-app-e40761499972d96071589ae0af65283a.jpg";